/* Otshirt — recherche predictive visuelle (facon Doofinder).
   - grille de cartes produit a grandes images
   - raccourci collection quand ca matche
   - puces de filtre par type de produit (affinage en 1 clic)
   - bloc "Recherches populaires" a l'ouverture (best-sellers + saisonnier)
   - re-ranking best-sellers Amazon
   Panneau unique ancre au viewport (jamais coupe par les conteneurs). */
(function () {
  "use strict";

  var DEBOUNCE_MS = 200, MIN_CHARS = 2, LIMIT = 12;
  function shownCount() { return window.innerWidth >= 750 ? 12 : 8; }

  // puces de filtre : libelle -> mot-clef ajoute a la requete (present dans les titres)
  var FILTERS = [
    ["T-shirts", "t-shirt"], ["Sweats", "sweat"], ["Mugs", "mug"],
    ["Doudous", "doudou"], ["Boxers", "boxer"], ["Débardeurs", "débardeur"],
    ["Maillots", "maillot"], ["Bodys bébé", "body"], ["Bavoirs", "bavoir"],
    ["Tabliers", "tablier"], ["Sacs", "sac"], ["Gourdes", "gourde"]
  ];

  // themes best-sellers (evergreen) — remontent aussi via le re-ranking
  var EVERGREEN = ["Papa", "Maman", "Moto", "Pêche", "Retraite", "Padel",
                   "Mamie", "Papy", "Chasse", "Anniversaire"];
  // saisonnier par mois (0=janvier)
  var SEASON = {
    0: ["Galette", "Nouvel an"], 1: ["Saint-Valentin", "Amour"],
    2: ["Pâques", "Printemps"], 3: ["Pâques", "Muguet"],
    4: ["Fête des mères", "Maîtresse"], 5: ["Fête des pères", "EVJF", "Mariage"],
    6: ["Vacances", "Camping-car"], 7: ["Vacances", "Apéro"],
    8: ["Rentrée", "Maîtresse"], 9: ["Halloween"],
    10: ["Noël", "Secret Santa"], 11: ["Noël", "Secret Santa"]
  };

  var bsIndex = null;  // [{t:titre,u:url,i:image,p:prix,s:ventes,_n:titre_normalise}]
  var scriptEl = document.currentScript;
  var idxUrl = scriptEl && scriptEl.getAttribute("data-bsindex");

  var panel = null, activeInput = null, selected = -1, lastQuery = "",
      controller = null, timer = null, curFilter = "";

  function norm(s) {
    return (s || "").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "");
  }

  function loadIndex() {
    if (!idxUrl) return;
    fetch(idxUrl).then(function (r) { return r.ok ? r.json() : null; })
      .then(function (a) {
        if (Array.isArray(a)) {
          a.forEach(function (it) { it._n = norm(it.t); });
          bsIndex = a;  // deja trie par ventes decroissantes
        }
      }).catch(function () {});
  }

  // cherche dans l'index best-sellers : titres contenant TOUS les mots (best-sellers d'abord)
  function localMatch(q, limit) {
    if (!bsIndex) return [];
    var words = norm(q).split(/\s+/).filter(Boolean);
    if (!words.length) return [];
    var out = [];
    for (var k = 0; k < bsIndex.length && out.length < limit; k++) {
      var it = bsIndex[k];
      var ok = words.every(function (w) { return it._n.indexOf(w) >= 0; });
      if (ok) out.push({ title: it.t, url: it.u, image: it.i, price: it.p });
    }
    return out;
  }
  function imgUrl(s, w) { return s ? s.replace(/(\.[a-z]+)(\?|$)/i, "_" + w + "x$1$2") : ""; }
  function productImg(p) { return p.image || (p.featured_image && p.featured_image.url) || ""; }
  function formatPrice(p) {
    if (p == null) return ""; var n = parseFloat(p);
    return isNaN(n) ? "" : n.toFixed(2).replace(".", ",") + " €";
  }
  function shortTitle(t) {
    // coupe au 1er separateur " | " ou " - " (espaces requis : garde "Camping-Car")
    var s = (t || "").split(/\s[|–\-]\s/)[0].trim();
    return s.length > 52 ? s.slice(0, 50).trim() + "…" : s;
  }
  function esc(s) { var d = document.createElement("div"); d.textContent = s || ""; return d.innerHTML; }

  function ensurePanel() {
    if (panel) return panel;
    panel = document.createElement("div");
    panel.className = "ots-ps";
    panel.hidden = true;
    document.body.appendChild(panel);
    panel.addEventListener("mousedown", function (e) {
      if (e.target.closest("a")) return;
      e.preventDefault();  // garde le focus dans l'input
    });
    panel.addEventListener("click", function (e) {
      var chip = e.target.closest("[data-filter]");
      if (chip) { e.preventDefault(); applyFilter(chip.getAttribute("data-filter")); return; }
      var term = e.target.closest("[data-term]");
      if (term) { e.preventDefault(); fillTerm(term.getAttribute("data-term")); }
    });
    return panel;
  }

  function position() {
    if (!activeInput || !panel || panel.hidden) return;
    var r = activeInput.getBoundingClientRect();
    var desktop = window.innerWidth >= 750;
    var m = desktop ? 16 : 8;
    var left, w;
    if (desktop) {
      // quasi pleine largeur, centre sur l'ecran (plafond confort a 1600px)
      w = Math.min(window.innerWidth - 2 * m, 1600);
      left = Math.round((window.innerWidth - w) / 2);
    } else {
      w = Math.max(r.width, 320);
      left = r.left;
      if (left + w > window.innerWidth - m) left = Math.max(m, window.innerWidth - w - m);
    }
    panel.style.left = left + "px";
    panel.style.top = (r.bottom + 6) + "px";
    panel.style.width = w + "px";
    panel.style.maxHeight = (window.innerHeight - r.bottom - 20) + "px";
  }

  function close() { if (panel) panel.hidden = true; selected = -1; }

  function applyFilter(kw) {
    curFilter = kw;
    if (activeInput && lastQuery) { renderLoading(); doSearch(lastQuery); }
  }
  function fillTerm(term) {
    if (!activeInput) return;
    activeInput.value = term;
    lastQuery = term; curFilter = "";
    activeInput.focus();
    renderLoading(); doSearch(term);
  }

  function trendingTerms() {
    var m = new Date().getMonth();
    var seen = {}, out = [];
    (SEASON[m] || []).concat(EVERGREEN).forEach(function (t) {
      var k = t.toLowerCase();
      if (!seen[k]) { seen[k] = 1; out.push(t); }
    });
    return out.slice(0, 10);
  }

  function renderTrending() {
    ensurePanel();
    var chips = trendingTerms().map(function (t) {
      return '<button type="button" class="ots-ps__term" data-term="' + esc(t) + '">' + esc(t) + '</button>';
    }).join("");
    panel.innerHTML = '<div class="ots-ps__head">Recherches populaires</div>' +
      '<div class="ots-ps__terms">' + chips + '</div>';
    panel.hidden = false; position();
  }

  function filterChips() {
    return '<div class="ots-ps__filters">' + FILTERS.map(function (f) {
      var on = curFilter === f[1] ? " is-on" : "";
      return '<button type="button" class="ots-ps__chip' + on + '" data-filter="' + f[1] + '">' + esc(f[0]) + '</button>';
    }).join("") + '</div>';
  }

  function renderLoading() {
    ensurePanel();
    panel.innerHTML = filterChips() + '<div class="ots-ps__loading">Recherche…</div>';
    panel.hidden = false; position();
  }

  function render(data, query) {
    ensurePanel();
    var products = data.products || [], collections = data.collections || [];
    var html = filterChips();
    if (collections.length) {
      html += '<div class="ots-ps__cols">' + collections.slice(0, 2).map(function (c) {
        return '<a class="ots-ps__col" href="' + c.url + '">📂 Voir la collection <b>' +
          esc(c.title) + '</b></a>';
      }).join("") + '</div>';
    }
    if (!products.length) {
      html += '<div class="ots-ps__empty">Aucun produit pour « ' + esc(query) + ' »</div>';
    } else {
      html += '<div class="ots-ps__head">Produits</div><div class="ots-ps__grid">' +
        products.slice(0, shownCount()).map(function (p, i) {
          var img = imgUrl(productImg(p), 300);
          return '<a class="ots-ps__card" role="option" data-idx="' + i + '" href="' + p.url + '">' +
            '<span class="ots-ps__imgwrap">' + (img ? '<img class="ots-ps__img" loading="lazy" src="' + img + '" alt="">' : '') + '</span>' +
            '<span class="ots-ps__name">' + esc(shortTitle(p.title)) + '</span>' +
            '<span class="ots-ps__price">' + formatPrice(p.price) + '</span></a>';
        }).join("") + '</div>' +
        '<a class="ots-ps__all" href="/search?q=' + encodeURIComponent(query) +
        '&type=product">Voir tous les résultats →</a>';
    }
    panel.innerHTML = html;
    panel.hidden = false; selected = -1; position();
  }

  function doSearch(q) {
    if (controller) controller.abort();
    controller = ("AbortController" in window) ? new AbortController() : null;
    var full = curFilter ? (q + " " + curFilter) : q;
    // best-sellers correspondants (index local, deja trie par ventes)
    var locals = localMatch(full, shownCount());
    var url = "/search/suggest.json?q=" + encodeURIComponent(full) +
      "&resources[type]=product,collection&resources[limit]=" + LIMIT +
      "&resources[options][unavailable_products]=hide";
    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (q !== lastQuery) return;
        var res = (((d || {}).resources || {}).results) || {};
        // fusion : best-sellers d'abord, puis suggestions live non deja presentes
        var seen = {}, merged = [];
        locals.forEach(function (p) { if (!seen[p.url]) { seen[p.url] = 1; merged.push(p); } });
        (res.products || []).forEach(function (p) {
          if (!seen[p.url]) { seen[p.url] = 1; merged.push(p); }
        });
        render({ products: merged, collections: res.collections || [] }, q);
      })
      .catch(function () {
        if (locals.length) render({ products: locals, collections: [] }, q);
      });
  }

  function onInput() {
    activeInput = this;
    var q = this.value.trim();
    lastQuery = q; curFilter = "";
    clearTimeout(timer);
    if (q.length < MIN_CHARS) { renderTrending(); return; }
    renderLoading();
    timer = setTimeout(function () { doSearch(q); }, DEBOUNCE_MS);
  }

  function onFocus() {
    activeInput = this;
    if (this.value.trim().length >= MIN_CHARS) onInput.call(this);
    else renderTrending();
  }

  function onKey(e) {
    if (!panel || panel.hidden) return;
    var items = panel.querySelectorAll(".ots-ps__card, .ots-ps__all");
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      selected += (e.key === "ArrowDown" ? 1 : -1);
      if (selected < 0) selected = items.length - 1;
      if (selected >= items.length) selected = 0;
      items.forEach(function (el, i) { el.classList.toggle("is-sel", i === selected); });
      if (items[selected]) items[selected].scrollIntoView({ block: "nearest" });
    } else if (e.key === "Enter" && selected >= 0 && items[selected]) {
      e.preventDefault(); window.location.href = items[selected].href;
    } else if (e.key === "Escape") { close(); }
  }

  function attach(input) {
    if (input.dataset.otsSearch) return;
    input.dataset.otsSearch = "1";
    input.setAttribute("autocomplete", "off");
    input.addEventListener("input", onInput);
    input.addEventListener("focus", onFocus);
    input.addEventListener("keydown", onKey);
  }
  function scan() {
    document.querySelectorAll('form[action*="/search"] input[name="q"], input[type="search"]').forEach(attach);
  }
  function init() {
    loadIndex(); ensurePanel(); scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener("click", function (e) {
      if (activeInput && !e.target.closest(".ots-ps") && e.target !== activeInput) close();
    });
    window.addEventListener("resize", position);
    window.addEventListener("scroll", position, true);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
